export const ReportType = {
    Manufacturer: 0,
    Wholesaler: 1
}